"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ColorSwatch: function() {
        return _index.ColorSwatch;
    },
    colorSwatchClassNames: function() {
        return _index.colorSwatchClassNames;
    },
    renderColorSwatch_unstable: function() {
        return _index.renderColorSwatch_unstable;
    },
    swatchCSSVars: function() {
        return _index.swatchCSSVars;
    },
    useColorSwatchStyles_unstable: function() {
        return _index.useColorSwatchStyles_unstable;
    },
    useColorSwatch_unstable: function() {
        return _index.useColorSwatch_unstable;
    }
});
const _index = require("./components/ColorSwatch/index");
